import { formatDate } from '@luxuryescapes/lib-refunds'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Typography from 'LuxKit/Typography/Typography'
import InlineIcon from 'components/utils/InlineIcon'
import type { ReactElement } from 'react'
import React from 'react'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

interface Props {
  icon?: ReactElement | false
  cancellationPolicy: App.BedbankCancellationPolicy
  showHotelOnly?: boolean
}

function BedbankPropertyCancellationPoliciesBase({ icon, cancellationPolicy, showHotelOnly = true }: Props) {
  const intl = useIntl()
  const hasRateCancellationPolicy = !!cancellationPolicy.policies.length

  const formattedDate = hasRateCancellationPolicy
    ? formatDate.formattedShortDateByTimezone(cancellationPolicy.policies[0]?.start, cancellationPolicy.policies[0]?.timezone)
    : undefined

  return <BodyTextBlock startIcon={icon} variant="medium">
    <Typography colour="highlight-secondary" as="b" wrap="no-wrap">
      {intl.formatMessage({
        id: 'aECa3E9nHy',
        defaultMessage: 'Free cancellation',
        description: 'Free cancellation text for bedbank property cancellation policy',
      })}
    </Typography>
    {hasRateCancellationPolicy && formattedDate && <>
      {' '}
      {intl.formatMessage(
        {
          id: 'mxnrm/EFXJ',
          defaultMessage: 'until {date}',
          description: 'Free cancellation until date text for bedbank property cancellation policy',
        },
        { date: formattedDate },
      )}
    </>}
    {' '}
    <Typography as="span" wrap="no-wrap">
      {showHotelOnly && intl.formatMessage({
        id: 'k1/TxwvBzO',
        defaultMessage: '(hotel only)',
        description: 'Hotel only qualifier text for bedbank property cancellation policy',
      })}
      <InlineIcon Icon={LineInfoCircleIcon} />
    </Typography>
  </BodyTextBlock>
}

export default BedbankPropertyCancellationPoliciesBase
